<template>

    <div class="result">

          <div class="index_cont">
            <div class='index_cont_container'>
              <img :src="require('@/assets/result/logo.png')" alt="" class="result_logo">
              <img :src="require('@/assets/result/hua.png')" alt="" class="result_hua">
              <img :src="require('@/assets/result/dai.png')" alt="" class="result_dai">
              <img :src="require('@/assets/result/ban.png')" alt="" class="result_ban">
              <img :src="require('@/assets/result/font.png')" alt="" class="result_font">
              <div class="result_qrcode">
                <img :src="require('@/assets/result/qrcode.png')" alt="">
                <div class='result_qrcode_tips'>扫码参与活动</div>
              </div>
              <div class='result_photo_container'>
                <img :src="require('@/assets/result/photo_container.png')" alt="" class="result_photo_container_bg" />
                <div class='result_photo_container_uploaded'>
                  <img v-if='imgSrc' :src='imgSrc' alt=''  />
                </div>
              </div>
            </div>
          </div>
        <div class='btn-container'>
          <img @click='goHome' :src="require('../../assets/result/re_btn.png')" alt="" class="btn-container-re">
          <img @click='generatePhoto' :src="require('../../assets/result/save_btn.png')" alt="" class="btn-container-save">
        </div>
        <van-overlay :show="!!generatedPhoto" @click="hideOverlay" class='photo-overlay'>
          <div class="generated-container" @click.stop>
            <img class="generated-container-photo" :src='generatedPhoto' />
            <div class="generated-container-tips">请长按图片进行保存</div>
            <img :src="require('@/assets/result/close.png')" @click="hideOverlay" alt='' class='generated-container-close' />
          </div>
        </van-overlay>
    </div>
</template>

<script>
    let wx = window.wx
    import { appendJs, getStore } from 'mulan-lib'
    import initWeixin from '@/util/wx'
    import html2canvas from 'html2canvas'
    import {Toast} from 'vant'
    export default {
    data(){
      return {
        fileList: [],
        imgSrc: getStore('imgSrc', 'session'),
        wxImgSrc: '',
        generatedPhoto: '',
      }
    },
      computed: {
        upLoader(){
          return this.$refs.upLoader
        }
      },
      methods: {

        init(localIds) {

        },
        hideOverlay() {
          this.generatedPhoto = ''
        },
        generatePhoto() {
          Toast.loading({
            message: '生成中...',
            forbidClick: true,
            loadingType: 'spinner',
          });
          html2canvas(document.querySelector(".index_cont_container"),
            {
              useCORS: true,
              scrollY: 0,
              scale: window.devicePixelRatio,
              backgroundColor: 'transparent',
            }
          ).then(canvas => {
            // canvas为转换后的Canvas对象
            this.generatedPhoto = canvas.toDataURL();  // 导出图片
            Toast.clear()
          });
        },
        goHome() {
          this.$router.push({path: '/Home'})
        }
      }
    }
</script>

<style lang="less" scoped>
    .pos(@w, @h, @t, @index) {
      width: @w / 2;
      height: @h / 2;
      top: @t / 2;
      z-index: @index;
      position: absolute;
    }
    .pos_l(@w,@h,@t,@l,@index) {
      .pos(@w, @h, @t, @index);
      left: @l / 2;
    }
    .pos_r(@w,@h,@t,@r,@index) {
      .pos(@w, @h, @t,@index);
      right: @r / 2;
    }
    .result{
        width: 100%;
        height: 100%;
        background-image: url('../../assets/result/bg.png');
        background-size: cover;
        background-position: 50%;
        background-repeat: no-repeat;
        box-sizing: border-box;
        position: relative;
        overflow: auto;
        .uploaded-photo {
          position: absolute; top: 200px; width: 200px;
        }
        .photo-overlay {
          display: flex;
          justify-content: center;
          align-items: center;
          z-index: 99;
          .generated-container {
            width: 60%;
            position: relative;
            &-photo {
              width: 100%;
              height: auto;
            }
            &-close {
              width: 30px;
              position: absolute;
              bottom: -70px;
              left: calc(50% - 30px / 2);
            }
            &-tips {
              width: 100%;
              position: absolute;
              bottom: -25px;
              color: #fff;
              font-weight: 700;
              font-size: 12px;
              text-align: center;
            }
          }
        }

        .btn-container {
          .pos_l(578px, 72px, 1037px, 87px, 1);
          display: flex;
          justify-content: space-between;
          &-re {
            width: 272px / 2;
            height: 100%;
          }
          &-save {
            width: 272px / 2;
            height: 100%;
          }
        }

        .index_cont{
            position:absolute;
            box-sizing: border-box;
            width: 512px / 2;
            height: 845px / 2;
            border-radius: 5px;
            top: 111px - 30;
            border: 3px solid #EA3D69;
            left: calc(50% - 512px/4);

            &_container {
              width: 100%;
              height: 100%;
              position: relative;
              background-image: url("../../assets/result/photo_bg.png");
              background-size: cover;
              background-position: 50%;
              background-repeat: no-repeat;
            }

            .result_logo{
              .pos_l(169px, 131px, 27px, 27px, 9);
            }
            .result_hua{
              .pos_r(300px, 279px, 0, 0, 9);
            }
            .result_dai{
              .pos_l(143px, 114px, 168px, 15px, 9);
            }
            .result_font{
              .pos_r(319px, 122px, 668px, 0, 9);
            }
            .result_ban{
              .pos_l(97px, 94px, 623px, 0, 9);
            }
            .result_qrcode {
              .pos_l(120px, 120px, 705px, 5px, 9);
              /* overflow: hidden; */
              /* padding: 3px; */
              /* background-color: #fff; */
              /* border: 3px solid #EA3D69; */
              border-left:0;
              border-bottom: 0;
              opacity: .8;
              z-index: 19;
              text-align: center;
              /* border-radius: 0 5px 0 0; */
              img {
                width: 80%;
                position: relative;
                left: 10%;
              }
              &_tips {
                width: 100%;
                font-size: 8px;
                text-align:center;
                color: #333;
              }
            }
            .result_photo_container {
              .pos_l(512px, 527px, 164px, 0, 1);
              &_uploaded {
                .pos_l(400px, 500px, 20px, 60px, 1);
                transform: rotate(-4deg);
                padding: 10px;
                box-sizing: border-box;
                display: flex;
                justify-content: center;
                img {
                  height: 100%;
                  width: auto;
                  max-width: 100%;
                }
              }
            }
        }

    }
</style>
